<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <b-col
            v-if="isMobile()"
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-space_between mb-1 mb-md-0"
          >
            <div class="bulk_selection d-flex">
              <div class="action-left pt-50">
                <b-form-checkbox
                  :checked="selectArchivedWorkFlowCheckbox"
                  :indeterminate="isSelectArchivedWorkFlowCheckboxIndeterminate"
                  @change="selectAllCheckboxUpdate"
                >
                  Select All
                </b-form-checkbox>
              </div>
              <b-dropdown
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="mx-1"
                right
                text="Bulk Actions"
                variant="primary"
                :disabled="!selectedWorkFlows.length"
              >
                <b-dropdown-item
                  v-if="canViewThisAction('update', 'WorkFlow')"
                  v-b-modal.modal-update-status-archived-work-flow-bulk
                >
                  Update Status
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="canViewThisAction('delete', 'WorkFlow')"
                  @click="deleteBulkWorkFlows"
                >
                  Delete Workflow(s)
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <span class="text-muted">Showing <br>{{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>
          <!-- Per Page -->
          <b-col
            v-else
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <div class="action-left pt-50">
              <b-form-checkbox
                :checked="selectArchivedWorkFlowCheckbox"
                :indeterminate="isSelectArchivedWorkFlowCheckboxIndeterminate"
                @change="selectAllCheckboxUpdate"
              >
                Select All
              </b-form-checkbox>
            </div>
            <b-dropdown
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mx-1"
              right
              text="Bulk Actions"
              variant="primary"
              :disabled="!selectedWorkFlows.length"
            >
              <!-- <b-dropdown-item @click="downloadBulkCSV">
                Download CSV
              </b-dropdown-item> -->
              <b-dropdown-item
                v-if="canViewThisAction('update', 'WorkFlow')"
                v-b-modal.modal-update-status-archived-work-flow-bulk
              >
                Update Status
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canViewThisAction('delete', 'WorkFlow')"
                @click="deleteBulkWorkFlows"
              >
                Delete Workflow(s)
              </b-dropdown-item>
            </b-dropdown>
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-form-archived-work-flow"
                ref="filter_dropdown_archived_work_flow"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <work-flow-filters
                  :status-filter.sync="statusFilter"
                  :category-filter.sync="categoryFilter"
                  :created-at.sync="createdAtFilter"
                  :status-options="statusOptions"
                  :category-options="categoryOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="createdAtFilter || categoryFilter.length || statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="entity in categoryFilter"
                  :key="entity"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromCategoryFilter(entity)"
                  >
                    <span class="text-capitalize">{{ resolveCategoryName(entity) }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-if="createdAtFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="createdAtFilter = ''"
                  >
                    {{ createdAtFilter }}
                  </b-form-tag>
                </li>
                <li
                  v-for="statusVal in statusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal.replace("-", " ") }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refArchivedWorkFlowsTable"
        class="position-relative event_list min-height-200"
        :items="fetchWorkFlows"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(name)="data">
          <div class="text-nowrap">
            <b-form-checkbox
              :checked="selectedWorkFlows.includes(data.item._id)"
              @change="toggleSelectedWorkFlows(data.item._id)"
              @click.native.stop
            >
              <b-button
                v-if="canViewThisAction('show', 'WorkFlow')"
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="link"
                class="weight-600 align-middle detail-view-id"
                :to="{ name: 'operation-workflows-show', params: { id: data.item._id } }"
              >
                {{ data.item.name }}
              </b-button>
              <b-button
                v-else
                v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                variant="none"
                class="text-bold-black align-middle detail-view-id not-button"
              >
                {{ data.item.name }}
              </b-button>
            </b-form-checkbox>
          </div>
        </template>

        <template #cell(customerBookable)="data">
          <div class="text-nowrap">
            <span class="text-capitalize">{{ data.item.customerBookable === true ? 'Yes' : 'No' }}</span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.createdBy.name }}</span>
            <br>
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveWorkFlowStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'WorkFlow') || canViewThisAction('update', 'WorkFlow') || canViewThisAction('delete', 'WorkFlow')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'WorkFlow')"
              :to="{ name: 'operation-workflows-show', params: { id: data.item._id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('create', 'WorkFlow')"
              @click="duplicateEntity(data.item._id)"
            >
              <feather-icon icon="CopyIcon" />
              <span class="align-middle ml-50">Duplicate</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'WorkFlow')"
              :to="{ name: 'operation-workflows-edit', params: { id: data.item._id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('delete', 'WorkFlow')"
              @click="deleteEntity(data.item._id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalWorkFlows > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalWorkFlows"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

    <b-modal
      id="modal-update-status-archived-work-flow-bulk"
      ref="update-status-modal-archived-bulk"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Status"
      @ok="updateBulkStatus"
    >
      <b-form @submit.prevent="updateBulkStatus">
        <validation-observer
          ref="archivedWorkFlowsBulkStatusEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-event-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-event-status"
                v-model="bulkStatus"
                label="title"
                :options="statusDataOptions"
                :reduce="title => title.code"
                :clearable="false"
                @input="bulkStatusValidation == true ? bulkStatusValidation = false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="bulkStatusValidation"
                class="text-danger"
              >
                {{ bulkStatusError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormInput, BTable, BFormCheckbox, BInputGroup, BInputGroupAppend,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm, BFormGroup, BButton, BFormTag,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import store from '@/store'

import useArchivedWorkFlowList from './useArchivedWorkFlowList'
import workFlowStoreModule from '../workFlowStoreModule'
import WorkFlowFilters from '../WorkFlowFilters.vue'

export default {
  components: {
    // UserListAddNew,
    BButton,
    BForm,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    vSelect,

    WorkFlowFilters,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    categoryOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      bulkStatus: 'archived',
      bulkStatusValidation: false,
      bulkStatusError: 'Valid status is required',
      statusDataOptions: [
        { title: 'Active', code: 'active' },
        { title: 'Archived', code: 'archived' },
      ],
      showFilterDropdown: process.env.VUE_APP_SHOW_FILTER_DROPDOWN,

      required,
    }
  },

  watch: {
    dataDuplicated: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$emit('emitCountWorkFlow')
        }
      },
    },
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_archived_work_flow.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_archived_work_flow.show(true)
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },

    removeFromCategoryFilter(item) {
      const index = this.categoryFilter.indexOf(item)
      if (index > -1) {
        this.categoryFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.createdAtFilter = ''
      this.categoryFilter = []
      this.statusFilter = []
    },
    resolveCategoryName(val) {
      const category = this.categoryOptions.find(o => o._id === val)
      if (category) {
        return category.name || ''
      }
      return ''
    },
    updateBulkStatus() {
      this.$refs.archivedWorkFlowsBulkStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.bulkStatus)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.selectedWorkFlows.length; i++) {
            formData.append('workFlows[]', this.selectedWorkFlows[i])
          }

          this.$http.patch('operation/work-flows/action/bulk/status/update', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.refetchData()
              this.$emit('emitCountWorkFlow')
              this.$swal({
                title: 'Status Updated!',
                html: 'The status for selected work flows has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'bulkStatus') {
                    this.bulkStatusError = validationError.msg
                    this.bulkStatusValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    deleteBulkWorkFlows() {
      this.$swal({
        title: 'Are you sure?',
        html: 'This will <strong>delete</strong> selected work flow(s). This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Go Back',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.selectedWorkFlows.length; i++) {
              formData.append('workFlows[]', this.selectedWorkFlows[i])
            }

            this.$http.patch('operation/work-flows/action/bulk/delete', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.refetchData()
                this.$emit('emitCountWorkFlow')
                this.confirmCustomerVal = ''
                this.selectedWorkFlows = []
                // this.$nextTick(() => {
                //   this.$refs['update-status-modal'].toggle('#toggle-btn')
                // })
                this.$swal({
                  title: 'Workflows Deleted!',
                  html: 'Selected work flows has been deleted',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/save.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Are You Sure?',
        html: 'Selecting Delete will <strong>permanently delete</strong> this item. This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, Cancel',
        confirmButtonText: 'Yes, Delete!',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deleteWorkFlow()
          }
        })
    },
    duplicateEntity(id) {
      const workflow = this.workFlowData.find(o => o._id === id)
      this.$swal({
        title: `Are you sure you want to duplicate ${workflow.name} workflow?`,
        html: `This will automatically create another copy of ${workflow.name} workflow.`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/question.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes, Proceed',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.duplicateWorkFlow()
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const WORK_FLOW_APP_STORE_MODULE_NAME = 'app-archived-work-flows'

    // Register module
    if (!store.hasModule(WORK_FLOW_APP_STORE_MODULE_NAME)) store.registerModule(WORK_FLOW_APP_STORE_MODULE_NAME, workFlowStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(WORK_FLOW_APP_STORE_MODULE_NAME)) store.unregisterModule(WORK_FLOW_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Active', value: 'active' },
      { label: 'Archived', value: 'archived' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchWorkFlows,
      tableColumns,
      perPage,
      currentPage,
      totalWorkFlows,
      workFlowData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refArchivedWorkFlowsTable,
      refetchData,

      toDeletedID,
      deleteWorkFlow,
      duplicateWorkFlow,
      dataDuplicated,

      // UI
      resolveWorkFlowStatusVariant,

      // Extra Filters
      statusFilter,
      categoryFilter,
      createdAtFilter,
    } = useArchivedWorkFlowList()

    const selectedWorkFlows = ref([])
    const toggleSelectedWorkFlows = workFlowId => {
      const workFlowIndex = selectedWorkFlows.value.indexOf(workFlowId)

      if (workFlowIndex === -1) selectedWorkFlows.value.push(workFlowId)
      else selectedWorkFlows.value.splice(workFlowIndex, 1)
    }
    const selectArchivedWorkFlowCheckbox = computed(() => workFlowData.value.length && (workFlowData.value.length === selectedWorkFlows.value.length))
    const isSelectArchivedWorkFlowCheckboxIndeterminate = computed(() => Boolean(selectedWorkFlows.value.length) && workFlowData.value.length !== selectedWorkFlows.value.length)
    const selectAllCheckboxUpdate = val => {
      selectedWorkFlows.value = val ? workFlowData.value.map(flow => flow._id) : []
    }

    return {

      // Sidebar

      fetchWorkFlows,
      tableColumns,
      perPage,
      currentPage,
      totalWorkFlows,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refArchivedWorkFlowsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteWorkFlow,
      duplicateWorkFlow,
      workFlowData,
      dataDuplicated,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveWorkFlowStatusVariant,

      statusOptions,

      // Extra Filters
      statusFilter,
      categoryFilter,
      createdAtFilter,

      selectArchivedWorkFlowCheckbox,
      isSelectArchivedWorkFlowCheckboxIndeterminate,
      selectedWorkFlows,
      toggleSelectedWorkFlows,
      selectAllCheckboxUpdate,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
